import '@progress/kendo-theme-default/dist/all.css';

import React, { useMemo, useState} from "react";
import LinkButton from "../../../components/common/link/LinkButton";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { FieldWrapper } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";

import InnerPanel from './InnerPanel';

import ActionButtons from '../../../components/common/buttons/ActionButtons';

import {
    Checkbox,
    TextArea,
  } from "@progress/kendo-react-inputs";

import {ROUTE_SKILL_SCHEDULER} from "../../../constants/routeConstants";
import ContentWrapper from '../../../components/common/wrapper/ContentWrapper';

import styles from "../schedulePageStyles.module.css"
import marginStyles from "../../../styles/marginstyles.module.css"
import gridStyles from "../../../styles/gridstyles.module.css"

import ClearFix from '../../../components/common/ClearFix';

import { useNavigate } from 'react-router-dom';
import ReverseScheduleFormPart from './schedule/ReverseScheduleFormPart';
import GroupFormPart from './groups/GroupFormPart';
import SkillLevelFormPart from './skills/SkillLevelFormPart';
import { SkillLevelsUserSet } from '../../../model/SkillScheduleModel';
import ValidatedInput from '../../../components/validation/ValidatedInput';
import { FIELD_GENERAL, FIELD_NAMES_REV_SCH, FIELD_NAMES_SCH, FIELD_SCH_NAME, FIELD_GROUP } from '../../../validation/SkillSchedulerValidation';
import ValidationField from '../../../components/validation/ValidationField';
import ScheduleFormPartWrapper from './schedule/ScheduleFormPartWrapper';

import InfoBox from '../../../components/common/info/InfoBox';
import ExecuteButton from '../../../components/common/buttons/ExecuteButton';
import YesNoModal from '../../../components/common/modal/YesNoModal';
import { useDispatch, useSelector } from 'react-redux';

import {changeSkillLevels, reverseSkillLevels} from "../../../store/skillSchedules/skillSchedule-actions";

const statuses = ["Ok", "Creating", "Updating", "Deleting", "Error"];

const InnerSkillScheduleForm = props => {
    const {token} = useSelector(state => state.auth);
    const {isCreate} = props;
    const {onSave, onCancel, onReload, onChange} = props;
    const {skillSchedule} = props;
    const {validationState} = props;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [expandedState, setExpandedState] = useState([panelIds.schedule]);
    const expandAll = !!validationState && validationState.active; 

    const [executeModalState, setExecuteModalState] = useState({showModal: false, prompt: ""});

    console.log("InnerSkillScheduleForm")
    console.log(skillSchedule)

    const isProcessing = !!skillSchedule && skillSchedule.isProcessing;
    const isChanged = !!skillSchedule && skillSchedule.isChanged;

    const isCreating = skillSchedule && skillSchedule.scheduleState === statuses[1];
    const isUpdating = skillSchedule && skillSchedule.scheduleState === statuses[2];
    const isDeleting = skillSchedule && skillSchedule.scheduleState === statuses[3];
    const isError = skillSchedule && skillSchedule.scheduleState === statuses[4];

    const blockSave = isProcessing || isCreating || isUpdating || isDeleting;
    
    const groupId = useMemo(() => {
        if (!skillSchedule) return null;
        if (!skillSchedule.body) return null;
        if (!skillSchedule.body.length) return null;

        const body = skillSchedule.body[0];
        if (!body) return null;
        if (!body.groupIds) return null;
        if (!body.groupIds.length) return null;
        return body.groupIds[0];
    }, [skillSchedule]);

    const skillLevels = useMemo(() => {
        if (!skillSchedule) return [];
        if (!skillSchedule.body) return [];
        if (!skillSchedule.body.length) return [];

        const body = skillSchedule.body[0];
        if (!body) return [];
        if (!body.skillLevels) return [];
        return body.skillLevels;
    }, [skillSchedule])

    /*
    const dispatchWorkingSkillSchedule = useCallback((newWorkingCallerList) => {
        dispatch(callerListActions.setWorkingCallerList({callerList: newWorkingCallerList}));
    }, [dispatch]);*/

    const handleNavigateBack = () => {
        navigate(ROUTE_SKILL_SCHEDULER)
    }

    const handleOnSave = () => {
        if (onSave) onSave();
    }

    const handleOnCancel = () => {
        if (onCancel) onCancel();
    }

    const handleOnReload = () => {
        if (onReload) onReload();
    }

    const handleChange = (field, value) => {
        if (!field) return;
        const newSkillSchedule = {...skillSchedule};
        newSkillSchedule[field] = value;
        if (onChange) onChange(newSkillSchedule);
    }

    const handleScheduleChange = schedule => {
        console.log("hierdus")
        console.log(schedule)
        handleChange("schedule", schedule);
    }

    const handleReverseScheduleChange = schedule => {
        handleChange("reverseSchedule", schedule);
    }

    const handleNameChange = e => {
        handleChange("name", e.value);
    }

    const handleActiveChange = e => {
        handleChange("enabled", e.value);
    }

    const handleDescriptionChange = e => {
        handleChange("description", e.value);
    }

    const handleGroupChange = newGroupId => {
        if (!skillSchedule) return;

        let newSkillLevelUserSet = new SkillLevelsUserSet();

        if (skillSchedule.body && skillSchedule.body.length) {
           const skillLevelUserSet = skillSchedule.body[0];
           if (skillLevelUserSet) newSkillLevelUserSet = {...skillLevelUserSet};
        }

        if (!newSkillLevelUserSet.groupIds) newSkillLevelUserSet.groupIds = [];

        newSkillLevelUserSet.groupIds[0] = newGroupId;

        handleChange("body", [newSkillLevelUserSet]);
    }

    const handleSkillLevelsChange = newSkillLevels => {
        if (!skillSchedule) return;
        if (!skillSchedule.body) return;

        let newSkillLevelUserSet = new SkillLevelsUserSet();

        if (skillSchedule.body && skillSchedule.body.length) {
           const skillLevelUserSet = skillSchedule.body[0];
           if (skillLevelUserSet) newSkillLevelUserSet = {...skillLevelUserSet};
        }

        newSkillLevelUserSet.skillLevels = newSkillLevels;

        handleChange("body", [newSkillLevelUserSet]);
    }

    const handleSelect = (e) => {
        if (!e) return;
        if (!e.target) return;
        if (!e.target.props) return;
        const id = e.target.props.id;
        if (!id) return;

        setExpandedState((current) => {
            const newState = [...current];
            const idx = current.indexOf(id);

            if (idx === -1) {
                newState.push(id);
            } else {
                newState.splice(idx, 1);
            }

            return newState;
        })
    }

    const handleExecuteClicked = () => {
        setExecuteModalState({
            showModal: true, 
            prompt: `Are you sure you wish to execute the schedule? Confirming will ${isChanged ? "reverse the skill levels to their original state" : "set the skill levels as configured"}`
        })
    }

    const handleExecuteCanceled = () => {
        setExecuteModalState({showModal: false, prompt: ""})
    }

    const handleExecuteConfirmed = () => {
        setExecuteModalState({showModal: false, prompt: ""})
        if (!skillSchedule) return;
        if (!skillSchedule.name) return;
        if (isChanged) {
            dispatch(reverseSkillLevels(token, skillSchedule.name));
        } else {
            dispatch(changeSkillLevels(token, skillSchedule.name));
        }
    }

    return (<>
        {!!executeModalState.showModal && <YesNoModal title="Execute schedule" 
            onClose={handleExecuteCanceled}
            onCancel={handleExecuteCanceled}
            onConfirm={handleExecuteConfirmed}
            prompt={executeModalState.prompt}
            secondPrompt={"Do not use this button too often in a short timespan. This may cause the execution to fail. Try to wait two minutes after every try"}
        />}
    <ContentWrapper>
        <div className={`${marginStyles.mb_10} ${marginStyles.mt_10}`}>
            <LinkButton 
                text="Back to list"
                onClick={handleNavigateBack}
            />
        </div>

        {isChanged && <InfoBox 
            text="The schedule is currently reversed. Until the reverse schedule has been executed you will be unable to remove the reverse schedule."
            type="info"
        />}
        
        {isProcessing && <InfoBox 
            text="The schedule is currently processing. You will be unable to change the schedule until the processing has concluded."
            type="warn"
        />}

        {isCreating && <InfoBox 
            text="The schedule is currently being created. You cannot modify the schedule when the creation process has not yet been completed."
            type="warn"
        />}

        {isUpdating && <InfoBox 
            text="The schedule is currently being updated. You cannot modify the schedule when the update process has not yet been completed."
            type="warn"
        />}

        {isDeleting && <InfoBox 
            text="The schedule is currently being deleted."
            type="error"
        />}

        {isError && <InfoBox 
            text="The schedule is currently in an error state. For more details, run a healthcheck. You can also try to restore it by saving it again. As longs as the error persists, the schedule will not be executed."
            type="error"
        />}

        <ValidationField 
            name={FIELD_GENERAL}
            validationState={validationState}
        />

        <section className={`${styles.section}`}>
        <div className={`${marginStyles.mb_10}`}>
            <div className={gridStyles.column_50_no_pad}>
            <FieldWrapper >
                <ValidatedInput
                    label={"Schedule name"}
                    name={FIELD_SCH_NAME}
                    style={{
                    width: "100%",
                    }}
                    //pattern={"[A-Za-z]+"}
                    minLength={2}
                    value={skillSchedule && skillSchedule.name ? skillSchedule.name : ""}
                    type="text"
                    disabled={!isCreate}
                    onChange={handleNameChange}
                    validationState={validationState}
                />
            </FieldWrapper>
            </div>
            <div className={gridStyles.column_50_no_pad} style={{textAlign: "right"}}>
                <Label>&nbsp;</Label><br/>
                <Checkbox  
                    size={"medium"} 
                    rounded={"medium"} 
                    label="Active" 
                    onChange={handleActiveChange}
                    value={!!skillSchedule.enabled}
                />
            </div>
            <ClearFix />
        </div>
        <FieldWrapper>
            <Label>Description</Label>
            <TextArea 
                name="description"
                value={skillSchedule && skillSchedule.description ? skillSchedule.description : ""}
                onChange={handleDescriptionChange}
            />
        </FieldWrapper>

        </section>

        <section className={styles.section} id="schedPanelBarWrapper">
        <PanelBar isControlled={true} expanded={expandAll ? allPanelIds : expandedState} onSelect={handleSelect}>
            <PanelBarItem className={isSelectedClass(expandedState, panelIds.schedule, expandAll)} title="Schedule" id={panelIds.schedule}>
                <InnerPanel>
                    <ScheduleFormPartWrapper
                        schedule={skillSchedule ? skillSchedule.schedule : null}
                        onChange={handleScheduleChange}
                        validationState={validationState}
                        names={FIELD_NAMES_SCH}
                    />
                </InnerPanel>
            </PanelBarItem>
            <PanelBarItem className={isSelectedClass(expandedState, panelIds.reverse, expandAll)} title="Reverse schedules" expanded={expandAll} id={panelIds.reverse}>
                <InnerPanel>
                    <ReverseScheduleFormPart 
                        isChanged={isChanged}
                        reverseSchedule={skillSchedule ? skillSchedule.reverseSchedule : null}
                        onChange={handleReverseScheduleChange}
                        validationState={validationState}
                        names={FIELD_NAMES_REV_SCH}
                    />
                </InnerPanel>
            </PanelBarItem>
            <PanelBarItem className={isSelectedClass(expandedState, panelIds.skills, expandAll)} title="Skill levels" expanded={expandAll} id={panelIds.skills}>
                <InnerPanel>
                    <SkillLevelFormPart
                        skillLevels={skillLevels}
                        onChange={handleSkillLevelsChange}
                        validationState={validationState}
                    />
                </InnerPanel>
            </PanelBarItem>
            <PanelBarItem className={isSelectedClass(expandedState, panelIds.agents, expandAll)} title="Agent group" expanded={expandAll} id={panelIds.agents}>
                <InnerPanel>
                    <GroupFormPart 
                        groupId={groupId}
                        onChange={handleGroupChange}
                        validationState={validationState}
                        name={FIELD_GROUP}
                    />
                </InnerPanel>
            </PanelBarItem>
        </PanelBar>
        </section>
        <div className={gridStyles.row}>
            <div>
            <div className={gridStyles.column_50}>
                {!isCreate && <ExecuteButton
                    onClick={handleExecuteClicked}
                    disabled={!skillSchedule || isError || isCreating || isDeleting || isUpdating || isProcessing}
                />}
                {isCreate && <><div>&nbsp;</div><ClearFix /></>}
            </div>
            <div className={gridStyles.column_50}>
                <ActionButtons 
                    onSave={handleOnSave}
                    onCancel={handleOnCancel}
                    onReload={handleOnReload}
                    showReload={true}
                    saveDisabled={blockSave}
                />
            </div>
            
        <ClearFix />
        </div>
        </div>
    </ContentWrapper>
    </>)
}

export default InnerSkillScheduleForm;

const panelIds = {
    schedule: "pnl_schedule",
    agents: "pnl_agents",
    skills: "pnl_skills",
    reverse: "pnl_reverse",
    groups: "pnl_groups"
}

const allPanelIds = Object.entries(panelIds).map(([key, value]) => value);

const isSelected = (selectedState, id, expandAll) => {
    if (expandAll) return true;
    if (!selectedState) return false;
    if (!id) return false;
    return selectedState.includes(id);
}

const isSelectedClass = (selectedState, id, expandAll) => {
    return isSelected(selectedState, id, expandAll) ? "k-force-selected" : "k-force-unselected";
}